import React from 'react';
import { LazySection } from './LazySection';
export function Garantia() {
  return <LazySection className="bg-cream-dark !py-[60px] md:!py-[80px]" data-id="element-154">
      <div className="container-custom" data-id="element-155">
        <div className="max-w-[720px] mx-auto bg-white border-2 border-gold rounded-[20px] p-8 md:px-10 md:py-11 text-center relative shadow-soft" data-id="element-156">
          <div className="inline-block bg-ink text-gold-light px-4 py-2 rounded-full text-[12px] font-semibold tracking-[0.15em] mb-4" data-id="element-157">
            🛡️ GARANTÍA 7 DÍAS · SIN PREGUNTAS
          </div>
          <h2 className="text-[clamp(24px,3.5vw,32px)] mb-4" data-id="element-158">
            Si no es para vos, te devolvemos el 100%.
          </h2>
          <p className="text-ink-soft text-[15px] leading-[1.6] mb-4" data-id="element-159">
            Abrís el sistema. Hacés el primer módulo. Si en 7 días sentís que no
            era lo que buscabas — te devolvemos todo. Sin formularios. Sin
            preguntas incómodas. Solo escribinos y listo.
          </p>
          <div className="bg-cream-dark p-5 rounded-xl font-serif italic text-[16px] text-ink leading-[1.5] mb-4" data-id="element-160">
            El riesgo es cero.{' '}
            <strong className="not-italic font-medium" data-id="element-161">
              Lo que podés perder si no lo probás es otro año repitiendo lo
              mismo.
            </strong>
          </div>
          <p className="text-[12px] text-ink-soft italic opacity-70" data-id="element-162">
            La mayoría de las mujeres que empiezan el proceso se quedan — porque
            desde el módulo 1 algo se mueve.
          </p>
        </div>
      </div>
    </LazySection>;
}